export default __webpack_public_path__ + "static/media/smartphone.295d8936.webp";